import { registerBlock } from "./registry";

registerBlock({
  type: "heading",
  title: "Heading",
  icon: "H2",
  defaultContent: "Heading"
});
